import React, { useEffect, useState } from 'react'
import { GiTeapotLeaves } from "react-icons/gi";
import { fetchAllDataAPI } from '../../utils/api';
import moment from 'moment';
import { Table } from 'react-bootstrap';
import withAuth from '../../utils/withAuth';

const LeaveReport = () => {
    const [leave, setLeave] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getLeaveReport();
    }, []);

    const getLeaveReport = () => {
        setIsLoading(true);
        fetchAllDataAPI('hr-get-leave-report').then((res) => {
            if (res.data.status === 1) {
                setLeave(res.data.leave || []);
            } else {
                setLeave([]);
            }
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
        });
    }

    const renderSkeletonRows = () => {
        return Array(5).fill(0).map((_, index) => (
            <tr key={index}>
                {Array(7).fill(0).map((__, idx) => (
                    <td key={idx}>
                        <div className="skeleton skeleton-text w-75"></div>
                    </td>
                ))}
            </tr>
        ));
    }

    const renderNoDataFound = () => {
        return (
            <tr>
                <td colSpan="7" className="text-center text-secondary py-4">
                    🛑 No Leave Records Found!
                </td>
            </tr>
        );
    }

    return (
        <div className="card radius-10 overflow-hidden w-100 topsection">
            <div className="leavetitle d-flex align-items-center border-bottom">
                <div className="title mb-1">
                    <h5 className="mb-0">Leave Report</h5>
                </div>
                <div className="icons mb-1">
                    <GiTeapotLeaves />
                </div>
            </div>

            <div className="bodysection">
                <div className="leavebody table-responsive">
                    <Table className="table-sm table-fixeds" responsive striped bordered hover>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Leave Type</th>
                                <th>From Date</th>
                                <th>End Date</th>
                                <th>Request Date</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                renderSkeletonRows()
                            ) : leave.length > 0 ? (
                                leave.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?.emp_name}</td>
                                        <td>{item?.leave_type}</td>
                                        <td>{moment(item?.leave_start_date).format('Do MMM YYYY')}</td>
                                        <td>{moment(item?.leave_end_date).format('Do MMM YYYY')}</td>
                                        <td>{moment(item?.request_date).format('Do MMM YYYY')}</td>
                                        <td>
                                            {(() => {
                                                if (item?.leave_status === "Approved") {
                                                    return <span className="badge bg-success text-white">{item.leave_status}</span>;
                                                } else if (item?.leave_status === "Pending") {
                                                    return <span className="badge bg-warning text-dark">{item.leave_status}</span>;
                                                } else if (item?.leave_status === "Reject") {
                                                    return <span className="badge bg-danger text-white">{item.leave_status}</span>;
                                                } else {
                                                    return <span className="badge bg-secondary text-white">Unknown</span>;
                                                }
                                            })()}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                renderNoDataFound()
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Leave Type</th>
                                <th>From Date</th>
                                <th>End Date</th>
                                <th>Request Date</th>
                                <th>Status</th>
                            </tr>
                        </tfoot>
                    </Table>
                </div>
            </div>

            {/* Skeleton CSS */}
            <style jsx="true">{`
                .skeleton {
                    background-color: #e2e2e2;
                    border-radius: 4px;
                    animation: shimmer 1.5s infinite linear;
                    height: 12px;
                    margin-bottom: 6px;
                }
                @keyframes shimmer {
                    0% { background-position: -400px 0; }
                    100% { background-position: 400px 0; }
                }
            `}</style>
        </div>
    )
}

export default withAuth(LeaveReport)
